import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';
import { Block } from 'components/block';
import {
  useBlockEditMode,
  useCurrentEditingBlock,
} from 'components/block/utils';
import { AddButton } from 'components/buttons/add-button';
import { useEmployee } from 'hooks';
import { InterestsForm, InterestsFormProps } from 'user/forms/interests-form';

export const InterestsBlock: FC = () => {
  const { t } = useTranslation();
  const { setCurrentEditingBlock, currentEditingBlock } =
    useCurrentEditingBlock();

  const formName = 'interests-form';

  const { form, isEditMode, buttons, setIsEditMode } = useBlockEditMode({
    formName,
  });

  const { employee } = useEmployee();

  const interestsFormProps: InterestsFormProps = {
    editMode: isEditMode,
    form,
    formName,
    setIsEditMode,
  };

  const extra =
    isEditMode || employee?.interests ? (
      buttons
    ) : currentEditingBlock ? (
      <Tooltip title="Complete editing in another section to modify this">
        <span>
          <AddButton disabled />
        </span>
      </Tooltip>
    ) : (
      <AddButton
        onClick={() => {
          setIsEditMode(true);
          setCurrentEditingBlock(formName);
        }}
      />
    );

  return (
    <Block title={t('Interests')} extra={extra}>
      <InterestsForm {...interestsFormProps} />
    </Block>
  );
};
